function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
/**
 * @module widget/verticalnavigationhandler
 */

/**
 * Returns 'keydown' handler for up/down arrow keys that modifies the caret movement if it's in a text line next to an object.
 *
 * @param {module:engine/controller/editingcontroller~EditingController} editing The editing controller.
 * @returns {Function}
 */

export default function verticalNavigationHandler(editing) {
  var model = editing.model;
  return function (evt, data) {
    var arrowUpPressed = data.keyCode == keyCodes.arrowup;
    var arrowDownPressed = data.keyCode == keyCodes.arrowdown;
    var expandSelection = data.shiftKey;
    var selection = model.document.selection;

    if (!arrowUpPressed && !arrowDownPressed) {
      return;
    }

    var isForward = arrowDownPressed; // Navigation is in the opposite direction than the selection direction so this is shrinking of the selection.
    // Selection for sure will not approach any object.

    if (expandSelection && selectionWillShrink(selection, isForward)) {
      return;
    } // Find a range between selection and closest limit element.


    var range = findTextRangeFromSelection(editing, selection, isForward);

    if (!range || range.isCollapsed) {
      return;
    } // If the range is a single line (there is no word wrapping) then move the selection to the position closest to the limit element.
    //
    // We can't move the selection directly to the isObject element (eg. table cell) because of dual position at the end/beginning
    // of wrapped line (it's at the same time at the end of one line and at the start of the next line).


    if (isSingleLineRange(editing, range, isForward)) {
      model.change(function (writer) {
        var newPosition = isForward ? range.end : range.start;

        if (expandSelection) {
          var newSelection = model.createSelection(selection.anchor);
          newSelection.setFocus(newPosition);
          writer.setSelection(newSelection);
        } else {
          writer.setSelection(newPosition);
        }
      });
      evt.stop();
      data.preventDefault();
      data.stopPropagation();
    }
  };
} // Finds the range between selection and closest limit element (in the direction of navigation).
// The position next to limit element is adjusted to the closest allowed `$text` position.
//
// Returns `null` if, according to the schema, the resulting range cannot contain a `$text` element.
//
// @param {module:engine/controller/editingcontroller~EditingController} editing The editing controller.
// @param {module:engine/model/selection~Selection} selection The current selection.
// @param {Boolean} isForward The expected navigation direction.
// @returns {module:engine/model/range~Range|null}
//

function findTextRangeFromSelection(editing, selection, isForward) {
  var model = editing.model;

  if (isForward) {
    var startPosition = selection.isCollapsed ? selection.focus : selection.getLastPosition();
    var endPosition = getNearestNonInlineLimit(model, startPosition, 'forward'); // There is no limit element, browser should handle this.

    if (!endPosition) {
      return null;
    }

    var range = model.createRange(startPosition, endPosition);
    var lastRangePosition = getNearestTextPosition(model.schema, range, 'backward');

    if (lastRangePosition && startPosition.isBefore(lastRangePosition)) {
      return model.createRange(startPosition, lastRangePosition);
    }

    return null;
  } else {
    var _endPosition = selection.isCollapsed ? selection.focus : selection.getFirstPosition();

    var _startPosition = getNearestNonInlineLimit(model, _endPosition, 'backward'); // There is no limit element, browser should handle this.


    if (!_startPosition) {
      return null;
    }

    var _range = model.createRange(_startPosition, _endPosition);

    var firstRangePosition = getNearestTextPosition(model.schema, _range, 'forward');

    if (firstRangePosition && _endPosition.isAfter(firstRangePosition)) {
      return model.createRange(firstRangePosition, _endPosition);
    }

    return null;
  }
} // Finds the limit element position that is closest to startPosition.
//
// @param {module:engine/model/model~Model} model
// @param {<module:engine/model/position~Position>} startPosition
// @param {'forward'|'backward'} direction Search direction.
// @returns {<module:engine/model/position~Position>|null}
//


function getNearestNonInlineLimit(model, startPosition, direction) {
  var schema = model.schema;
  var range = model.createRangeIn(startPosition.root);
  var walkerValueType = direction == 'forward' ? 'elementStart' : 'elementEnd';

  var _iterator = _createForOfIteratorHelper(range.getWalker({
    startPosition: startPosition,
    direction: direction
  })),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref2 = _step.value;
      var previousPosition = _ref2.previousPosition;
      var item = _ref2.item;
      var type = _ref2.type;

      if (schema.isLimit(item) && !schema.isInline(item)) {
        return previousPosition;
      } // Stop looking for isLimit element if the next element is a block element (it is for sure not single line).


      if (type == walkerValueType && schema.isBlock(item)) {
        return null;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
} // Basing on the provided range, finds the first or last (depending on `direction`) position inside the range
// that can contain `$text` (according to schema).
//
// @param {module:engine/model/schema~Schema} schema The schema.
// @param {module:engine/model/range~Range} range The range to find the position in.
// @param {'forward'|'backward'} direction Search direction.
// @returns {module:engine/model/position~Position} The nearest selection range.
//


function getNearestTextPosition(schema, range, direction) {
  var position = direction == 'backward' ? range.end : range.start;

  if (schema.checkChild(position, '$text')) {
    return position;
  }

  var _iterator2 = _createForOfIteratorHelper(range.getWalker({
    direction: direction
  })),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref4 = _step2.value;
      var nextPosition = _ref4.nextPosition;

      if (schema.checkChild(nextPosition, '$text')) {
        return nextPosition;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
} // Checks if the DOM range corresponding to the provided model range renders as a single line by analyzing DOMRects
// (verifying if they visually wrap content to the next line).
//
// @param {module:engine/controller/editingcontroller~EditingController} editing The editing controller.
// @param {module:engine/model/range~Range} modelRange The current table cell content range.
// @param {Boolean} isForward The expected navigation direction.
// @returns {Boolean}
//


function isSingleLineRange(editing, modelRange, isForward) {
  var model = editing.model;
  var domConverter = editing.view.domConverter; // Wrapped lines contain exactly the same position at the end of current line
  // and at the beginning of next line. That position's client rect is at the end
  // of current line. In case of caret at first position of the last line that 'dual'
  // position would be detected as it's not the last line.

  if (isForward) {
    var probe = model.createSelection(modelRange.start);
    model.modifySelection(probe); // If the new position is at the end of the container then we can't use this position
    // because it would provide incorrect result for eg caption of image and selection
    // just before end of it. Also in this case there is no "dual" position.

    if (!probe.focus.isAtEnd && !modelRange.start.isEqual(probe.focus)) {
      modelRange = model.createRange(probe.focus, modelRange.end);
    }
  }

  var viewRange = editing.mapper.toViewRange(modelRange);
  var domRange = domConverter.viewRangeToDom(viewRange);
  var rects = Rect.getDomRangeRects(domRange);
  var boundaryVerticalPosition;

  var _iterator3 = _createForOfIteratorHelper(rects),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rect = _step3.value;

      if (boundaryVerticalPosition === undefined) {
        boundaryVerticalPosition = Math.round(rect.bottom);
        continue;
      } // Let's check if this rect is in new line.


      if (Math.round(rect.top) >= boundaryVerticalPosition) {
        return false;
      }

      boundaryVerticalPosition = Math.max(boundaryVerticalPosition, Math.round(rect.bottom));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return true;
}

function selectionWillShrink(selection, isForward) {
  return !selection.isCollapsed && selection.isBackward == isForward;
}